import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

export const adminGuard: CanActivateFn = (route, state) => {
  const msalService = inject(MsalService);
  const router = inject(Router);

  // List of authorized admin emails
  const authorizedAdmins = [
    'kevin.cheng@harpercollins.com',
    'mdjafar.abdali@harpercollins.com',
    'alex.spence@harpercollins.com',
    'dinesh.kumar@harpercollins.com',
    'alison.park@harpercollins.com',
    'sam.wong@harpercollins.com',
  ];

  // Get the current user's account
  const accounts = msalService.instance.getAllAccounts(); 
  if (accounts.length === 0) {    router.navigate(['/']);
    return false;
  }

  // Get the user's email from the account
  const userEmail = accounts[0].username?.toLowerCase();// Check if the user's email is in the authorized list
  if (userEmail && authorizedAdmins.includes(userEmail)) {    return true; // Allow access
  }  alert('You are not authorized to access the admin area.');
  router.navigate(['/']);
  return false;
};

